import type { SummarySource } from "./api/selectSummarySource";

/**
 * Who sends the session summary to the partner tool:
 *  - `frontend`: this browser dispatches `SessionSummary_Submit`.
 *  - `backend-gaia`: session-summary-sender sends it. GAIA reports its own summaries to the sender, so the
 *    browser sends nothing.
 *  - `backend-simplr`: session-summary-sender sends it. Logic Builder publishes its own summaries to the
 *    sender's Kafka topic, so the browser sends nothing.
 *
 * With `sendSummaryFromBackend` on (Verizon), a Simplr-served summary goes out from the browser until
 * `sendSimplrSummaryFromBackend` is on. The sender reads the same flag, so flipping it moves the send to the
 * backend without a gap or a double send.
 */
export type SummaryDelivery = "frontend" | "backend-gaia" | "backend-simplr";

export const selectSummaryDelivery = ({
    sendSummaryFromBackend,
    sendSimplrSummaryFromBackend,
    servedBy,
}: {
    sendSummaryFromBackend: boolean;
    sendSimplrSummaryFromBackend: boolean;
    servedBy: SummarySource;
}): SummaryDelivery => {
    if (!sendSummaryFromBackend) return "frontend";
    if (servedBy !== "simplr") return "backend-gaia";
    return sendSimplrSummaryFromBackend ? "backend-simplr" : "frontend";
};
